import axios from "axios";
import qs from "qs";
const initialState = {
	user: {
		
	}
};
export const state = { ...initialState };

export const actions = {
	async checkSession (context) {
		return axios.get("/api/session").then(function(response){
			context.commit("setUser", response.data);
		})
	},

	async signout(context) {
		return axios.get("/api/signout").then(function(response) {
			context.commit("clearUser");
		});
	},

	setUserData(context,data){
		context.commit('setUser',data);
	},

	clearUserData(context){
		context.commit('clearUser');
	},
}

export const mutations = {
	setUser(state,data){
		state.user = data;
	},
   

	clearUser(state){
		state.user = {
			
		};
	},
}

const getters = {
	user(state){
		return state.user;
	},
};

export default {
	state,
	actions,
	mutations,
	getters
  };
  